module.exports = __webpack_public_path__ + "img/top_bg.39a66288.png";